import styled from '@emotion/styled/macro';

import { Box, BoxProps } from './Box';

export type FlexProps = Partial<BoxProps>;

export const Flex = styled(Box)({
  display: 'flex',
});
